import React from 'react';
import { Download, CheckCircle, XCircle, Clock } from 'lucide-react';

const BillingHistoryItem = ({ record }) => {
  const getStatusIcon = () => {
    switch (record?.paymentStatus) {
      case 'paid':
        return <CheckCircle className="w-5 h-5 text-green-600" />;
      case 'failed':
        return <XCircle className="w-5 h-5 text-red-600" />;
      case 'pending':
        return <Clock className="w-5 h-5 text-yellow-600" />;
      default:
        return <Clock className="w-5 h-5 text-gray-600" />;
    }
  };

  const getStatusColor = () => {
    switch (record?.paymentStatus) {
      case 'paid':
        return 'text-green-600';
      case 'failed':
        return 'text-red-600';
      case 'pending':
        return 'text-yellow-600';
      default:
        return 'text-gray-600';
    }
  };

  return (
    <div className="flex items-center justify-between p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors">
      <div className="flex items-center space-x-4">
        <div className="flex-shrink-0">
          {getStatusIcon()}
        </div>
        <div>
          <div className="font-semibold text-gray-900">
            ${record?.amount} {record?.currency}
          </div>
          <div className="text-sm text-gray-600">
            {new Date(record?.createdAt)?.toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
          </div>
        </div>
      </div>
      <div className="flex items-center space-x-4">
        <div className="text-right">
          <div className={`font-semibold capitalize ${getStatusColor()}`}>
            {record?.paymentStatus}
          </div>
          <div className="text-sm text-gray-600 capitalize">
            {record?.billingInterval}
          </div>
        </div>
        
        {record?.stripeInvoiceId && (
          <button
            onClick={() => window.open(`https://invoice.stripe.com/${record?.stripeInvoiceId}`, '_blank')}
            className="text-blue-600 hover:text-blue-700 transition-colors"
            title="Download Invoice"
          >
            <Download className="w-5 h-5" />
          </button>
        )}
      </div>
    </div>
  );
};

export default BillingHistoryItem;